import React, { useEffect, useState, useMemo } from 'react'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { TOASTS } from 'Components/Elements/Toaster/Toast.models'
import { useGetDomains } from 'Features/domainsManagement/api/getDomains'
import { Link, useLocation } from 'react-router-dom'
import { useZendeskChat } from 'src/hooks/zendesk/useZendeskChat'
import { useIsFirstLogin } from 'Hooks/useIsFirstLogin'
import { useHideBannersSplit } from 'Hooks/useHideBannersSplit'
import { TagInstallation } from 'Features/domainsManagement/components/TagInstallation/TagInstallation'

let errorWasShown = false
let errorWasHidden = false
const I18Key = '_tag_indication'

export const useTagIndicationNotification = () => {
  const location = useLocation()
  const { showSystemMessage, systemMessages, removeSystemMessage } = useAppStore()
  const { data: domains } = useGetDomains()
  const { openChat } = useZendeskChat()
  const [modalOpen, setModalOpen] = useState(false)
  const { isFirstLogin } = useIsFirstLogin()
  const { shouldHideBanners } = useHideBannersSplit()

  const domainsWithoutTag = useMemo(
    () => domains?.data?.domains.filter((domain) => !domain.tagInstalled) || [],
    [domains]
  )

  // Show the error message
  useEffect(() => {
    if (!isFirstLogin && !errorWasShown && domainsWithoutTag?.length && !shouldHideBanners)
      handleShowModal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domains, shouldHideBanners])

  // Hide the error message on route change
  useEffect(() => {
    if (errorWasShown && !errorWasHidden && systemMessages.length) {
      errorWasHidden = true
      const filteredId = systemMessages.find((msg) => msg.i18config.i18nKey.includes(I18Key))?.id
      if (filteredId) removeSystemMessage(filteredId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  const isSingleDomainWithoutTag = domainsWithoutTag.length === 1

  const handleShowModal = () => {
    errorWasShown = true
    const isMultipleDomains = domainsWithoutTag.length > 1
    const i18nKey = `system_messages.${isMultipleDomains ? 'multiple' : 'one'}${I18Key}`
    const values = { domainName: domainsWithoutTag[0]?.address } // Relevant only for one domain

    showSystemMessage(
      {
        i18nKey,
        values,
        components: {
          action: isMultipleDomains ? (
            <Link to="/domain-management" />
          ) : (
            <Link to="#" onClick={() => setModalOpen(true)} />
          ),
          support: <Link to="#" onClick={openChat} />,
        },
      },
      TOASTS.failure
    )
  }

  return {
    GetTagModal: isSingleDomainWithoutTag
      ? () => (
          <TagInstallation
            isOpen={modalOpen}
            domainAddress={domainsWithoutTag[0].address}
            onOpenChange={setModalOpen}
          />
        )
      : undefined,
  }
}
